import makeList from './makeList.js'

let viewFloor = '倉庫棟'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '倉庫棟２階入口',
        file: './data/I21_2.JPG',
        rotation: 119.10641872328165,
        link: [
          {
            file: './data/I21d_2.JPG',
            position: [ 1971.0447530108268, -732.1575693501828, -4532.256709671703 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 569.2307692307693, 505.3076923076924 ],
        },
      },
      { description: '倉庫棟２階廊下',
        file: './data/I21d_2.JPG',
        rotation: -166.32493823074736,
        link: [
          {
            file: './data/I21_2.JPG',
            position: [ -3956.3564568654447, 1474.5698920633026, 2663.316113163391 ],
          },
          {
            file: './data/I21c_2.jpg',
            position: [ 4243.815401181578, 623.5884999920253, -2554.4525446350876 ],
          },
          {
            file: './data/I21ab.JPG',
            position: [ -784.6778285293492, 2470.4295214363515, -4266.586690366897 ],
          },
          {
            file: './data/I21d.JPG',
            position: [ 3552.5721196286368, 2832.427662927267, 2076.9098721158234 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 512.8205128205128, 451.46153846153857 ],
        },
      },
      { description: '倉庫棟２階',
        file: './data/I21c_2.jpg',
        rotation: -73.73910144462661,
        link: [
          {
            file: './data/I21d_2.JPG',
            position: [ -4861.531191128736, -208.60569217950572, 1116.935493251446 ],
          },
          {
            file: './data/I21b.JPG',
            position: [ -4630.221117916592, -464.5981903710293, -1804.083731606496 ],
          },
          {
            file: './data/I21a_1.JPG',
            position: [ 815.6186658658767, -2893.433144935083, -3991.447682571905 ],
          },
          {
            file: './data/I18u_A.JPG',
            position: [ 4985.687501261058, -140.6516644640775, 167.64992435624592 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 371.7948717948718, 374.53846153846166 ],
        },
      },
      { description: '設営事務室',
        file: './data/I21b.JPG',
        rotation: 121.5217570786656,
        link: [
          {
            file: './data/I21c_2.jpg',
            position: [ 2641.9458439074633, 14.191505593231621, 4237.282334159406 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 464.10256410256414, 333.51282051282055 ],
        },
      },
      { description: '倉庫棟冷凍庫(中央)',
        file: './data/I21ab.JPG',
        rotation: -18.135007311294693,
        link: [
          {
            file: './data/I21ba.JPG',
            position: [ 4413.374547200791, -498.0405310838679, -2275.182758794539 ],
          },
          {
            file: './data/I21ca.JPG',
            position: [ -4558.1351438631245, -271.86825880880247, 2028.9056251970978 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 543.5897435897436, 402.74358974358984 ],
        },
      },
      { description: '倉庫棟冷凍庫(左)',
        file: './data/I21ba.JPG',
        rotation: 55.05811367295877,
        link: [
          {
            file: './data/I21ab.JPG',
            position: [ -3844.911697832397, -608.7214693595236, 3121.0130318131046 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 507.69230769230774, 371.9743589743591 ],
        },
      },
      { description: '倉庫棟冷凍庫(右)',
        file: './data/I21ca.JPG',
        rotation: -117.05774286929538,
        link: [
          {
            file: './data/I21ab.JPG',
            position: [ 4320.150097111073, -36.453039576778316, -2512.7369101423837 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 584.6153846153846, 436.0769230769231 ],
        },
      },
      { description: '倉庫棟冷蔵庫(手前)',
        file: './data/I21d.JPG',
        rotation: 7.788626413365558,
        link: [
          {
            file: './data/I21d_2.JPG',
            position: [ -4140.449851312179, 382.5159947145678, -2764.520333693708 ],
          },
          {
            file: './data/I21e.JPG',
            position: [ 3528.957116762415, 2.5742198324423824, 3532.2772413324824 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 472.5415070242657, 456.0395913154532 ],
        },
      },
      { description: '倉庫棟冷蔵庫(奥)',
        file: './data/I21e.JPG',
        rotation: 30.728515921591676,
        link: [
          {
            file: './data/I21d.JPG',
            position: [ -2822.155809084743, -16.952774969371912, -4120.123446270431 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 417.94871794871796, 492.4871794871797 ],
        },
      },
      { description: '倉庫棟１階',
        file: './data/I21a_1.JPG',
        rotation: 59.01078596219541,
        link: [
          {
            file: './data/I21c_2.jpg',
            position: [ 2067.8641777643265, 334.5675486646597, -4535.5781970649205 ],
          },
          {
            file: './data/I21bb_1.JPG',
            position: [ -4542.436621623357, 578.4037114505311, -1995.2354866603398 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 394.8717948717949, 418.1282051282053 ],
        },
      },
      { description: '倉庫棟１階(奥)',
        file: './data/I21bb_1.JPG',
        rotation: -100.58402951556064,
        link: [
          {
            file: './data/I21a_1.JPG',
            position: [ 3021.945471691097, -320.6220054639988, 3961.6698168612697 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 633.4610472541507, 408.68454661558104 ],
          syowaZoom: [ 458.974358974359, 392.4871794871797 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
